import { Button, ModalWindow, Snack } from "@tblabs/truffle";
import { SettingsEditor } from "./SettingsEditor";
import { SettingsEdit } from "./SettingsEdit";
import { Device } from "../../Services/Device";


export class SetupWindow extends ModalWindow
{
    constructor(device: Device)
    {
        super(`📡 ${device.Id} Setup`);
        this.WidthPercent(96).HeightPercent(92);

        const deviceSettings = new SettingsEdit(device.Config);

        this.AddContent(
            new SettingsEditor(deviceSettings, device),
        );

        this.AddToFooter(
            new Button("Save changes").Class("uk-button uk-button-danger").FloatLeft()
                .OnClick(() =>
                {
                    device.SendSettings(deviceSettings.Settings);

                    new Snack("Settings sent to device", "🕑 Awaiting validation result...", { clickAnywhereToClose: true, autoCloseTimeout: 1000 });
                }),
            new Button("Close", () => this.CloseWindow())
                .Class("uk-button uk-button-default").FloatRight(),
        )

        this.OpenWindow();
    }
}
